import { Program } from '@/store/program/types';

import { ProgramResponse } from '../initState/getProgram';

export function parseProgram(
	program: PromiseSettledResult<Program | null>,
	guide: PromiseSettledResult<ProgramResponse | null>,
): Program | null {
	if (program?.status === 'fulfilled' && program.value) {
		return program.value;
	}

	if (guide?.status === 'fulfilled' && guide.value?.program) {
		return guide.value?.program;
	}

	return null;
}
